import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickableProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img/Img";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { MarketingTileList } from "@NA/Services/GetBannerCarousel";
import React from "react";
import { css } from "styled-components";

export interface ADIPLPMarketingTileModel {
    container?: InjectableCss;
    marketingImg?: ImgProps;
    marketingTitle?: TypographyProps;
    marketingContent?: TypographyProps;
    marketingButton?: ButtonPresentationProps;
}

interface OwnProps {
    marketingTile: MarketingTileList;
}

const adiPLPMarketingTileStyles: ADIPLPMarketingTileModel = {
    container: {
        css: css`
            border: 1px solid ${getColor("text.disabled")};
            border-radius: 5px;
            height: 100%;
            background-position: top center;
            background-repeat: no-repeat;
            background-size: 100% auto;
            padding: 20px;
            position: relative;
            display: flex;
            flex-direction: column;
        `,
    },
    marketingButton: {
        css: css`
            width: 100%;
            margin-bottom: 10px;
            min-height: 40px;
            background-color: ${getColor("primary")};
            border-radius: 7px;
            box-shadow: inset 0 -4px 0 0 ${getColor("secondary")};
            text-align: center;
            display: block;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: 800;
            color: #fff;
            padding: 14px;
            margin-top: auto;
        `,
    },
    marketingContent: {
        as: "span",
        css: css`
            color: #002856;
            display: block;
            margin-bottom: 20px;
            text-align: center;
            white-space: pre-line;
        `,
    },
    marketingImg: {
        css: css`
            max-height: 175px;
            margin-bottom: 20px;
        `,
    },
    marketingTitle: {
        as: "h4",
        css: css`
            font-size: 26px;
            font-weight: 300;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #002856;
            margin-bottom: 5px;
            white-space: pre-line;
        `,
    },
};

const styles = adiPLPMarketingTileStyles;

const ADIPLPMarketingTile = ({ marketingTile }: OwnProps) => {
    return (
        <StyledWrapper
            {...styles.container}
            style={{
                backgroundImage: marketingTile.backgroundImage ? `url(${marketingTile.backgroundImage})` : "",
            }}
        >
            {marketingTile.imageURL && <Img {...styles.marketingImg} src={marketingTile.imageURL} />}
            <StyledWrapper style={{ flex: 1 }} />
            {marketingTile.headerLineOne && (
                <Typography {...styles.marketingTitle}>{marketingTile.headerLineOne.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            {marketingTile.copyTextOne && (
                <Typography {...styles.marketingContent}>{marketingTile.copyTextOne.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            {marketingTile.copyTextTwo && (
                <Typography {...styles.marketingContent}>{marketingTile.copyTextTwo.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            {marketingTile.copyTextThree && (
                <Typography {...styles.marketingContent}>{marketingTile.copyTextThree.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            {marketingTile.smallCopyTextOne && (
                <Typography {...styles.marketingContent}>{marketingTile.smallCopyTextOne.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            {marketingTile.smallCopyTextTwo && (
                <Typography {...styles.marketingContent}>{marketingTile.smallCopyTextTwo.replace('<br>', '\n').replace('<br />', '\n')}</Typography>
            )}
            <StyledWrapper style={{ flex: 1 }} />
            {marketingTile.bannerLinkUrl && (
                <Link
                    href={marketingTile.bannerLinkUrl}
                    style={{ width: "100%" }}
                    typographyProps={{
                        css: css`
                            width: 100%;
                        `,
                    }}
                >
                    <Button {...styles.marketingButton} onClick={() => {}}>
                        {marketingTile.bannerButtonText}
                    </Button>
                </Link>
            )}
        </StyledWrapper>
    );
};

export default ADIPLPMarketingTile;
